var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#C5EEDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 28.167C36.5 32.881 36.5 35.2381 35.0355 36.7025C33.5711 38.167 31.214 38.167 26.5 38.167H21.5C16.786 38.167 14.4289 38.167 12.9645 36.7025C11.5 35.2381 11.5 32.881 11.5 28.167V19.8337C11.5 15.1196 11.5 12.7626 12.9645 11.2981C14.4289 9.83366 16.786 9.83366 21.5 9.83366H26.5C31.214 9.83366 33.5711 9.83366 35.0355 11.2981C36.5 12.7626 36.5 15.1196 36.5 19.8337V28.167Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.5C32 19.2766 32 19.6649 31.8782 19.9711C31.7158 20.3795 31.4043 20.704 31.0123 20.8731C30.7183 21 30.3455 21 29.6 21L18.4 21C17.6545 21 17.2817 21 16.9877 20.8731C16.5957 20.704 16.2842 20.3795 16.1218 19.9711C16 19.6649 16 19.2766 16 18.5C16 17.7234 16 17.3351 16.1218 17.0289C16.2842 16.6205 16.5957 16.296 16.9877 16.1269C17.2817 16 17.6545 16 18.4 16H29.6C30.3455 16 30.7183 16 31.0123 16.1269C31.4043 16.296 31.7158 16.6205 31.8782 17.0289C32 17.3351 32 17.7234 32 18.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23.5C32 24.2766 32 24.6649 31.8782 24.9711C31.7158 25.3795 31.4043 25.704 31.0123 25.8731C30.7183 26 30.3455 26 29.6 26L18.4 26C17.6545 26 17.2817 26 16.9877 25.8731C16.5957 25.704 16.2842 25.3795 16.1218 24.9711C16 24.6649 16 24.2766 16 23.5C16 22.7234 16 22.3351 16.1218 22.0289C16.2842 21.6205 16.5957 21.296 16.9877 21.1269C17.2817 21 17.6545 21 18.4 21H29.6C30.3455 21 30.7183 21 31.0123 21.1269C31.4043 21.296 31.7158 21.6205 31.8782 22.0289C32 22.3351 32 22.7234 32 23.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28.5C32 29.2766 32 29.6649 31.8782 29.9711C31.7158 30.3795 31.4043 30.704 31.0123 30.8731C30.7183 31 30.3455 31 29.6 31L18.4 31C17.6545 31 17.2817 31 16.9877 30.8731C16.5957 30.704 16.2842 30.3795 16.1218 29.9711C16 29.6649 16 29.2766 16 28.5C16 27.7234 16 27.3351 16.1218 27.0289C16.2842 26.6205 16.5957 26.296 16.9877 26.1269C17.2817 26 17.6545 26 18.4 26H29.6C30.3455 26 30.7183 26 31.0123 26.1269C31.4043 26.296 31.7158 26.6205 31.8782 27.0289C32 27.3351 32 27.7234 32 28.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Exel.9572c0c348d9cdd200c7ba6d5b0cad81.svg";